export const TILED_MENU = 'tailed-menu';
